<template>
  <div id="fws_67f7a402b511f" data-midnight="" data-column-margin="default" class="wpb_row vc_row-fluid vc_row inner_row" style="">
    <div class="row-bg-wrap">
      <div class="row-bg"></div>
    </div>
    <div class="row_col_wrap_12_inner col span_12  left">
      <div class="vc_col-sm-3 vc_col-lg-3 vc_col-md-2 vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
        <div class="vc_column-inner">
          <div class="wpb_wrapper">

          </div>
        </div>
      </div>
      <div class="vc_col-sm-6 vc_col-lg-6 vc_col-md-8 vc_col-xs-12 form-col wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
        <div class="vc_column-inner">
          <div class="wpb_wrapper">
            <h2 style="text-align: center; margin-top: -70px;" class="vc_custom_heading vc_do_custom_heading">
              Get in Touch
            </h2>
            <div class="wpb_text_column wpb_content_element" style="margin-top: -30px;">
              <div class="wpb_wrapper">
                <p style="text-align: center;">
                  As active members of the aviation community, we are happy to discuss all your maintenance training requirements. For more details or information on Part-145, Part-M, Part-147, or Part-66 training matters, contact our Training Team:
                </p>
                <p style="text-align: center; margin-bottom: 60px;">Please fill in the
                  short form below, and we will contact you as
                  soon as possible.
                </p>
              </div>
            </div>
            <div id="wpcf7-f69041-p119367-o1" class="wpcf7 no-js" lang="en-US" dir="ltr" data-wpcf7-id="69041">
              <form action="/technical-training/#wpcf7-f69041-p119367-o1" method="post" class="wpcf7-form init" aria-label="Contact form" novalidate="novalidate" data-status="init">
                <span>
                  Are you interested in courses as a private individual or on behalf of a business?
                  <span class="redStar">*</span>
                </span>

                <div class="columns">
                  <div class="column">
                    <b-radio-button v-model="form.is_private_person" native-value="Yes" type="is-success is-light" class="is-fullwidth client-type-selector">
                      <span>Private</span>
                    </b-radio-button>
                    <span v-if="form.errors.has('is_private_person')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("is_private_person") }}</span>
                  </div>
                  <div class="column">
                    <b-radio-button v-model="form.is_private_person" native-value="No" type="is-success is-light" class="is-fullwidth client-type-selector">
                      <span>Business</span>
                    </b-radio-button>
                  </div>
                </div>
                <p>
                  <label style="color: white !important;"> Your name, surname
                    <span class="redStar">*</span>
                    <span class="wpcf7-form-control-wrap" data-name="your-name">
                      <input v-model="form.name" :class="form.errors.has('name') ? 'wpcf7-not-valid' : ''" size="40" maxlength="400" class="has-text-white wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" type="text" name="your-name"/>
                      <span v-if="form.errors.has('name')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("name") }}</span>
                    </span>
                  </label>
                </p>
                <p>
                  <label style="color: white !important;"> E-mail
                    <span class="redStar">*</span>
                    <span class="wpcf7-form-control-wrap" data-name="your-email">
                      <input v-model="form.email" :class="form.errors.has('email') ? 'wpcf7-not-valid' : ''" size="40" maxlength="400" class="has-text-white wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email" aria-required="true" aria-invalid="false" type="email" name="your-email"/>
                      <span v-if="form.errors.has('email')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("email") }}</span>
                    </span>
                  </label>
                </p>
                <p v-if="form.is_private_person === 'No'">
                  <label style="color: white !important;"> Company
                    <span class="redStar">*</span>
                    <span class="wpcf7-form-control-wrap" data-name="company">
                      <input v-model="form.company" :class="form.errors.has('company') ? 'wpcf7-not-valid' : ''" size="40" maxlength="400" class="has-text-white wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" type="text" name="company"/>
                      <span v-if="form.errors.has('company')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("company") }}</span>
                    </span>
                  </label>
                </p>
                <p>
                  <label style="color: white !important;"> Phone
                    <span class="redStar"></span>
                    <span class="wpcf7-form-control-wrap" data-name="your-phone">
                      <input v-model="form.phone" :class="form.errors.has('phone') ? 'wpcf7-not-valid' : ''" size="40" maxlength="400" class="has-text-white wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" type="text" name="your-phone"/>
                      <span v-if="form.errors.has('phone')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("phone") }}</span>
                    </span>
                  </label>
                </p>
                <p>
                  <label style="color: white !important;"> Which courses are you interested in?
                    <span class="redStar">*</span>
                    <span class="wpcf7-form-control-wrap" data-name="your-courses">
                      <textarea v-model="form.courses_request" :class="form.errors.has('courses_request') ? 'wpcf7-not-valid' : ''" cols="40" rows="3" maxlength="2000" class="has-text-white wpcf7-form-control wpcf7-textarea" aria-invalid="false" name="your-courses"></textarea>
                      <span v-if="form.errors.has('courses_request')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("courses_request") }}</span>
                    </span>
                  </label>
                </p>
                <p>
                  <label style="color: white !important;"> Preferred starting date
                    <span class="wpcf7-form-control-wrap" data-name="starting-date">
                      <input v-model="form.starting_date" :class="form.errors.has('starting_date') ? 'wpcf7-not-valid' : ''" class="has-text-white wpcf7-form-control wpcf7-date wpcf7-validates-as-required wpcf7-validates-as-date required" min="2025-04-10" max="2030-12-31" step="1" aria-required="true" aria-invalid="false" type="text" name="starting-date"/>
                      <span v-if="form.errors.has('starting_date')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("starting_date") }}</span>
                    </span>
                  </label>
                </p>
                <p>
                  <label style="color: white !important;"> Size of the group
                    <span class="wpcf7-form-control-wrap" data-name="your-group-size">
                      <input v-model="form.group_size" :class="form.errors.has('group_size') ? 'wpcf7-not-valid' : ''" size="40" maxlength="400" class="has-text-white wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" type="text" name="your-group-size"/>
                      <span v-if="form.errors.has('group_size')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("group_size") }}</span>
                    </span>
                  </label>
                </p>
                <div style="margin-top:15px;" :data-sitekey="recaptcha_key" class="g-recaptcha" data-callback="onRecaptchaSuccess" data-expired-callback="onRecaptchaExpired"></div>
                <span v-if="form.errors.has('g_recaptcha_token')" class="wpcf7-not-valid-tip" aria-hidden="true">{{ form.errors.get("g_recaptcha_token") }}</span>
                <div class="has-text-centered">
                  <b-button v-if="!is_submitted" class="custom-quote-button" @click="submitForm">Send a quote</b-button>
                  <span v-else style="color: white !important;"><br>Thanks for contacting us! We’ve received your request and will respond as soon as possible.</span>
                </div>
                <div class="wpcf7-response-output" aria-hidden="true"></div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="vc_col-sm-3 vc_col-lg-3 vc_col-md-2 vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
        <div class="vc_column-inner">
          <div class="wpb_wrapper">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .client-type-selector .is-selected{
    background-color: #B9F419 !important;
  }
  .custom-quote-button {
    background-color: #B9F419 !important;
    border-color: #B9F419 !important;
    color: #000 !important;
    height: 50px;
    margin-top: 20px;
  }

  .custom-quote-button:hover {
    background-color: #d4ff4f !important;
    border-color: #d4ff4f !important;
  }

  .custom-quote-button:active {
    background-color: #a3d90f !important;
    border-color: #a3d90f !important;
  }
</style>

<script>
import Form from '../../helpers/Form/Form';

export default {
  name: 'ClassroomTrainingContactUsForm',
  props: {
    recaptcha_key: { required: true, type: String }
  },
  data() {
    return {
      is_submitted: false,
      form: new Form({
        is_private_person: null,
        name: null,
        email: null,
        company: null,
        phone: null,
        courses_request: null,
        starting_date: null,
        group_size: null,
        g_recaptcha_token: null
      }).dontResetAfterSuccess()
    };
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', function () {
      const hash = window.location.hash;
      if (hash === '#get-in-touch') {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    window.onRecaptchaSuccess = this.onRecaptchaSuccess;
    window.onRecaptchaExpired = this.onRecaptchaExpired;
  },
  methods: {
    submitForm() {
      this.form.post('/classroom-training/contact-us').then(() => {
        this.is_submitted = true;
      }).catch(() => {
        error('Some fields contain errors. Please correct them and try again.');
      });
    },
    onRecaptchaSuccess(token) {
      this.form.g_recaptcha_token = token;
    },
    onRecaptchaExpired() {
      this.form.g_recaptcha_token = null;
    }
  }
};
</script>
